import { ToastService } from "@shared/lib/services";
import {
  ACCOUNT_STATUS,
  BackednResponse,
  IGetOrganisations,
} from "@shared/lib/types";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { ORGANISATION_LIST_QUERY_KEY } from "../constants";
import { OrganisationService } from "../services/organisation.service";

export function useGetOrganisations(
  limit: number,
  pageNo: number,
  searchQuery?: string,
  status?: ACCOUNT_STATUS[],
  type?: string[],
  permissionedUserIds?: string[],
  companyName?: string[],
  industries?: string[]
) {
  const { data, isLoading, isError, error, isFetching } = useQuery<
    BackednResponse<IGetOrganisations>
  >({
    queryKey: [
      ...ORGANISATION_LIST_QUERY_KEY,
      searchQuery,
      limit,
      pageNo,
      status,
      type,
      permissionedUserIds,
      companyName,
      industries,
    ],
    queryFn: () =>
      OrganisationService.getOrganisations(
        limit,
        pageNo,
        searchQuery,
        status,
        type,
        permissionedUserIds,
        companyName,
        industries
      ),
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    organisations: data?.data,
    isError,
    isFetching: isLoading,
    isFetchingOrig: isFetching,
  };
}
